import React from 'react';

interface Props {
  id: string;
  label: string;
  checked?: boolean;
  disabled?: boolean;
  onChange: (e) => void;
}

const CheckboxField: React.FC<Props> = ({
  id,
  label,
  checked = false,
  disabled = false,
  onChange,
}) => (
  <React.Fragment>
    <div className="form-group">
      <input
        type="checkbox"
        name={id}
        id={id}
        defaultChecked={checked}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={id}>{label}</label>
    </div>
    {/* language=CSS */}
    <style jsx>{`
      .form-group {
        box-sizing: border-box;
        margin-bottom: 1rem;
        position: relative;
      }

      .form-group label {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        transition: all 100ms ease-in-out;
        cursor: default;
      }

      .checkbox-group label {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
      }
    `}</style>
  </React.Fragment>
);

export default CheckboxField;
